"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registry = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var createEntry_1 = require("./createEntry/createEntry");
exports.registry = createEntry_1.createEntry({
    host: editor_elements_conventions_1.Hosts.SiteAssets,
});
__exportStar(require("../toolbox"), exports);
__exportStar(require("../registry.types"), exports);
exports.default = exports.registry;
//# sourceMappingURL=siteAssets.js.map